/**
 * The three pieces every settings pane is built out of.
 *
 * They live here rather than in `Settings.tsx` because a pane that needs them
 * should not have to import the dialog that renders it, which is a circle.
 */

export function Label({ children }: { children: React.ReactNode }) {
  return (
    <h3 style={{ fontSize: 10, fontWeight: 700, letterSpacing: '.16em', textTransform: 'uppercase', color: 'var(--text-dim)', margin: '0 0 12px' }}>
      {children}
    </h3>
  )
}

export function Aside({ children }: { children: React.ReactNode }) {
  return (
    <p style={{ fontFamily: 'var(--font-human)', fontStyle: 'italic', fontSize: 13, color: 'var(--text-dim)', marginTop: 18 }}>
      {children}
    </p>
  )
}

export function Toggle({ on, onChange, label, disabled }: {
  on: boolean
  onChange: (next: boolean) => void
  label: string
  disabled?: boolean
}) {
  return (
    <button
      role="switch"
      aria-checked={on}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!on)}
      className="sp-tap"
      style={{
        width: 40, height: 23, flex: 'none', borderRadius: 20,
        cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.4 : 1,
        padding: 3, display: 'flex', justifyContent: on ? 'flex-end' : 'flex-start',
        background: on ? 'var(--accent)' : 'var(--panel-hover)', transition: 'background .18s',
      }}
    >
      <span style={{ width: 17, height: 17, borderRadius: '50%', background: on ? 'var(--ground)' : 'var(--text-dim)' }} />
    </button>
  )
}
